// Utils
import {
    API_FETCH_BASIC_DATA,
    API_FORM_IN_PROCESS,
    API_SAVE_CONTINUE,
    API_SUBMIT_FORM,
    APT_CREATE_MLE,
    APT_FETCH_MLE_DETAILS,
    APT_FETCH_MLE_DETAILS_PINCODE,
    APT_FETCH_MLE_LIST,
    APT_UPDATE_MLE,
} from '../../../utils/API/apiUrls';

import { POST } from '../../../utils/fetchWrappers';

// API URLs

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as merchantLegalEntityActions from './merchantLegalEntity.actions';

// constants
import {
    CREATE_MERCHANT_LEGAL_ENTITY_REQUEST,
    EDIT_MERCHANT_LEGAL_ENTITY_REQUEST,
    FETCH_BASIC_FORM_DATA_PROCESS_V1,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_REQUEST,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_REQUEST,
    FETCH_MERCHANT_LEGAL_ENTITY_REQUEST,
    FETCH_MLE_FORM_IN_PROCESS_REQUEST,
    SAVE_AND_CONTINUE_REQUEST_V1,
    SUBMIT_REQUEST_DATA_MLE,
} from './merchantLegalEntity.constants';

// Libs
import { takeLatest, put, call, takeEvery } from 'redux-saga/effects';
import moment from 'moment';
import { basicFormDataRes, mleDetailsres, saveAndContinueDetails, verifyBasicFormDataReq } from 'mockApiWiseReqRes';
import { FORM_TYPE, MOCK_API_VALUE } from 'utils/constants/commonValues';
import { BUSINESS_DETAILS_SAVE, FETCH_BASIC_FORMDATA_SUCCESS, FETCH_UPDATE_BUSINESS_DETAILS_FORMDATA, FETCH_UPDATE_OWNER_DETAILS_FORMDATA, OWNERSHIP_DETAILS_FETCH, OWNERSHIP_DETAILS_SAVE, VERIFY_BASIC_REQUEST } from 'mockApiWiseReqRes/mockApiWise.constants';
import * as loaderActions from 'redux/common/loader/loader.actions';
import { UBO_SECTION_TYPE } from 'components/Onboarding/Mle/UobTab/constant';
import { toast } from 'react-toastify';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from 'utils/constants/toastMessages';
import { FETCH_FORM_IN_PROCESS_REQUEST } from 'containers/MerchantOnboard/redux/merchantOnBoard.constants';
import { BASICFORM_MLE_UPDATE } from '../constants';
import { createDeepCopyObj } from 'utils/helperMethods';
import { MerchantLegalEntityListRequest } from './dtos/MerchantLegalEntityListRequest.dto';

export function* fetchMerchantLegalEntityList(actions) {
    try {
        const { payload } = actions;
        const res = new MerchantLegalEntityListRequest(payload);
        const { data } = yield call(POST, APT_FETCH_MLE_LIST, res);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                merchantLegalEntityActions.fetchMerchantLegalEntitySuccess(data)
            );
        } else if (data && data.errorMessage) {
            
            yield put(
                merchantLegalEntityActions.fetchMerchantLegalEntityFailure({
                    error: data,
                })
            );
        }
    } catch (e) {
        const errorMessage = e?.response?.data?.errorMessage || "";
        yield put(
            merchantLegalEntityActions.fetchMerchantLegalEntityFailure({
                error: {errorMessage},
            })
        );
    }
}

export function* createMerchantLegalEntity(actions) {
    try {
        const { payload } = actions;

        

        const { data } = yield call(POST, APT_CREATE_MLE, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                merchantLegalEntityActions.createMerchantLegalEntitySuccess(
                    data
                )
            );
        } else if (data && data.errorMessage) {
            yield put(
                merchantLegalEntityActions.createMerchantLegalEntityFailure({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            merchantLegalEntityActions.createMerchantLegalEntityFailure({
                error: data,
            })
        );
    }
}

export function* fetchMerchantLegalEntityDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;

        const { data } = yield call(POST, APT_FETCH_MLE_DETAILS, payload);
        
        if (data && data.statusCode === apiStatusCodes.SUCCESS2) {
            
            yield put(
                merchantLegalEntityActions.fetchMerchantLegalEntityDetailsSuccess(
                    {...data, ...payload}
                )
            );
            
        } else if (data && data.errorMessage) {
            yield put(
                merchantLegalEntityActions.fetchMerchantLegalEntityDetailsFailure(
                    {
                        error: data,
                    }
                )
            );
        }
    } catch (e) {
        const errorMessage = e?.message || "";
        yield put(
            merchantLegalEntityActions.fetchMerchantLegalEntityDetailsFailure({
                error: {errorMessage},
            })
        );
    }
    yield put(loaderActions.hideLoader());
}



export function* fetchMerchantLegalEntityDetailsPinCode(actions) {
    try {
        const { payload } = actions;

        const { data } = yield call(POST, APT_FETCH_MLE_DETAILS_PINCODE, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS2) {
            yield put(
                merchantLegalEntityActions.fetchMerchantLegalEntityDetailsPincodeSuccess(
                    data
                )
            );
        } else if (data && data.errorMessage) {
            yield put(
                merchantLegalEntityActions.fetchMerchantLegalEntityDetailsPincodeFailure(
                    {
                        error: data,
                    }
                )
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            merchantLegalEntityActions.fetchMerchantLegalEntityDetailsPincodeFailure({
                error: data,
            })
        );
    }
}


export function* editMerchantLegalEntity(actions) {
    try {
        const { payload } = actions;
        let data = {};
        if (MOCK_API_VALUE) {
            data = mleDetailsres();
        } else {
            data = yield call(POST, APT_UPDATE_MLE, payload).data;
        }
        
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                merchantLegalEntityActions.editMerchantLegalEntitySuccess(data)
            );
        } else if (data && data.errorMessage) {
            yield put(
                merchantLegalEntityActions.editMerchantLegalEntityFailure({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;

        yield put(
            merchantLegalEntityActions.editMerchantLegalEntityFailure({
                error: data,
            })
        );
    }
}

export function* fetchBasicFormData(payload) {
    
    let data = {};
    try {
        if (MOCK_API_VALUE) {
            let classificationVariable = FETCH_BASIC_FORMDATA_SUCCESS;
            if (payload?.payload?.formType === BASICFORM_MLE_UPDATE.business) {  
                classificationVariable = FETCH_UPDATE_BUSINESS_DETAILS_FORMDATA;
            } 
            if (payload?.payload?.sectionType === UBO_SECTION_TYPE) {
                classificationVariable = OWNERSHIP_DETAILS_FETCH;
                if (payload?.payload?.formType === BASICFORM_MLE_UPDATE.ubo)
                    classificationVariable = FETCH_UPDATE_OWNER_DETAILS_FORMDATA;
            }

            data = basicFormDataRes(classificationVariable);
    
        } else {
            
            
            const resp =  yield call(POST, API_FETCH_BASIC_DATA, payload?.payload);
            
            data = resp.data;
        }
        
        if (data?.statusCode == apiStatusCodes.SUCCESS2 || data?.statusCode == apiStatusCodes.SUCCESS) {
            
            if (payload?.payload?.sectionType === UBO_SECTION_TYPE) {
                yield put(merchantLegalEntityActions.fetchBasicFormDataSuccess({
                    uboBasicDetails: data
                }));
            } else {
                yield put(merchantLegalEntityActions.fetchBasicFormDataSuccess(data));
            } 
        } else {
            yield put(merchantLegalEntityActions.fetchBasicFormDataFailure({errorMessage: data?.errorMessage}));
        }
    } catch(e) {
        console.log("error message", e?.message);
        data = {errorMessage: e?.message || ""};
        yield put (merchantLegalEntityActions.fetchBasicFormDataFailure(data));
    }
}

function* saveAndContinueRequestV1({payload}) {
    yield put(loaderActions.showLoader());
    let data = {};
    try {
        
        if (MOCK_API_VALUE) {
            let type = BUSINESS_DETAILS_SAVE;
           
            if (payload?.sectionType === UBO_SECTION_TYPE) {
                type = OWNERSHIP_DETAILS_SAVE;
            }
            
            data = saveAndContinueDetails(type);
    
        } else {
            const resp =  yield call(POST, API_SAVE_CONTINUE, payload);
            data = resp.data;
        }
        
        if (data?.statusCode == apiStatusCodes.SUCCESS) {
            toast.success(SUCCESS_MESSAGES.MLE_UPDATED)
            yield put(merchantLegalEntityActions.saveAndContinueSuccessV1({...data, isSubmit: false}, payload?.sectionType));
        } else {
            toast.error(data.errorMessage);
            yield put(merchantLegalEntityActions.saveAndContinueFailedV1({errorMessage: data?.errorMessage}));
        }
    } catch(e) {
        
        data = {errorMessage: e?.message || ""};
        toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        yield put (merchantLegalEntityActions.saveAndContinueFailedV1(data));
    }
    yield put(loaderActions.hideLoader());
}

function* submitRequestV1({payload}) {
    yield put(loaderActions.showLoader());
    let data = {};
    try {
        let uniqueIdentifier = payload?.uniqueIdentifier;
        let formType = payload?.formType;
        let finalSubmitPayload = {
            uniqueIdentifier,
            formType
        };
        if (payload?.isEditMode || payload?.isReEditFlow) {
            finalSubmitPayload = createDeepCopyObj(payload);
            delete finalSubmitPayload.isEditMode;
        }
        const resp1 =  yield call(POST, API_SUBMIT_FORM, finalSubmitPayload);
        let data1 = resp1.data;
        if (data1?.statusCode == apiStatusCodes.SUCCESS) {
            let isSubmit = true;
            if (payload?.isEditMode || payload?.isReEditFlow) {
                if (formType === BASICFORM_MLE_UPDATE.business) {
                    toast.success(SUCCESS_MESSAGES.BUSINESS_SECTION_SUCCESS)
                } else if (formType === BASICFORM_MLE_UPDATE.ubo) {
                    toast.success(SUCCESS_MESSAGES.UBO_SECTION_SUCCESS)
                } else {
                    toast.success(SUCCESS_MESSAGES.MLE_UPDATED);
                }
            }
            
            yield put(merchantLegalEntityActions.submitSuccessMLE({ isSubmit }, payload?.sectionType));
        } else {
            toast.error(data1.errorMessage);
            yield put(merchantLegalEntityActions.submitFailureMle({ isSubmit: false }, payload?.sectionType));
        }
    } catch(e) {
        data = {errorMessage: e?.message || ""};
        toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        yield put (merchantLegalEntityActions.submitFailureMle(data));
    }
    yield put(loaderActions.hideLoader());
}


export function* fetchFormInProcessDetails() {
    
    yield put(loaderActions.showLoader());
    try {
        const request = {
            formType: FORM_TYPE.MLE_ON_BOARD,
        };
        const { data } = yield call(POST, API_FORM_IN_PROCESS, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(merchantLegalEntityActions.fetchMLEFormInProcessSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                merchantLegalEntityActions.fetchMLEFormInProcessError({
                    error: data,
                })
            );
        }
    } catch (e) {
        const data = {errorMessage: e?.message, statusCode: '400'};
        yield put(merchantLegalEntityActions.fetchMLEFormInProcessError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* merchantLegalEntitySaga() {
    yield takeLatest(
        FETCH_MERCHANT_LEGAL_ENTITY_REQUEST,
        fetchMerchantLegalEntityList
    );
    yield takeLatest(
        CREATE_MERCHANT_LEGAL_ENTITY_REQUEST,
        createMerchantLegalEntity
    );
    yield takeLatest(
        FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_REQUEST,
        fetchMerchantLegalEntityDetails
    );

    yield takeLatest(
        FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_REQUEST,
        fetchMerchantLegalEntityDetailsPinCode
    );

    yield takeLatest(
        EDIT_MERCHANT_LEGAL_ENTITY_REQUEST,
        editMerchantLegalEntity
    );

    yield takeEvery(
        FETCH_BASIC_FORM_DATA_PROCESS_V1,
        fetchBasicFormData
    );

    yield takeLatest(SAVE_AND_CONTINUE_REQUEST_V1, saveAndContinueRequestV1);

    yield takeLatest(FETCH_MLE_FORM_IN_PROCESS_REQUEST, fetchFormInProcessDetails);

    yield takeLatest(SUBMIT_REQUEST_DATA_MLE, submitRequestV1);
}
